import React from 'react';

interface PredefinedSearchSectionProps {
  location: string;
  location_id: number;
  category: string;
  category_id: number;
  subcategory?: string;
  subcategory_id?: number | null;
}

const PredefinedSearchSection: React.FC<PredefinedSearchSectionProps> = ({
  location,
  location_id,
  category,
  category_id,
  subcategory,
  subcategory_id
}) => {
  const handleSearch = () => {
    // Create search URL based on landing page criteria - use proper search endpoint
    const baseUrl = '/search';
    const params = new URLSearchParams();

    params.append('trainerAds', 'true');
    params.append('categoryId', category_id.toString());
    params.append('location', location_id.toString());

    if (subcategory_id) {
      params.append('subcategoryId', subcategory_id.toString());
    }

    const searchUrl = `${baseUrl}?${params.toString()}`;
    window.location.href = searchUrl;
  };

  return (
    <section className="landing-predefined-search">
      <div className="landing-container">
        <div className="landing-search-card">
          <div className="landing-search-header">
            <h2>Znajdź idealnego trenera dla siebie</h2>
            <p>Skorzystaj z dopasowanych filtrów dla {category.toLowerCase()} w {location}</p>
          </div>

          <div className="landing-search-filters">
            <div className="landing-search-filter">
              <label>Lokalizacja</label>
              <div className="landing-search-value">{location}</div>
            </div>

            <div className="landing-search-filter">
              <label>Kategoria</label>
              <div className="landing-search-value">{category}</div>
            </div>

            {subcategory && (
              <div className="landing-search-filter">
                <label>Specjalizacja</label>
                <div className="landing-search-value">{subcategory}</div>
              </div>
            )}
          </div>

          <div className="landing-search-actions">
            <button
              onClick={handleSearch}
              className="landing-search-button"
            >
              Zobacz dostępnych trenerów
            </button>

            <div className="landing-search-info">
              <span className="landing-search-bullet">✓</span>
              <span>Darmowa konsultacja</span>
            </div>
            <div className="landing-search-info">
              <span className="landing-search-bullet">✓</span>
              <span>Brak zobowiązań</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PredefinedSearchSection;